
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ['onChange', 'onEnter', 'onLeave'],
  data () {
    return {
      observer: {} as IntersectionObserver
    }
  },
  mounted () {
    this.observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) {
        this.$emit('onLeave', entries[0])
      } else {
        this.$emit('onEnter', entries[0])
      }
      this.$emit('onChange', entries[0])
    }, {
    })
    this.observer.observe((this.$refs.viewportEl as Element))
  },
  unmonunted () {
    this.observer.disconnect()
  }
})
